import { useEffect } from 'react';

import { notification } from 'antd';

import i18n from 'segments/i18n';

type Params = {
  successMessage?: string;
  errorMessage?: string;
  isSuccess?: boolean;
  isError?: boolean;
  onSuccess?: () => void;
  onError?: () => void;
  error?: unknown;
};

export const useNotification = (params: Params) => {
  const {
    isSuccess,
    isError = false,
    successMessage = i18n.t('notifications.success', 'Операция успешно совершена'),
    errorMessage,
    onSuccess,
    onError,
    error
  } = params;

  let filteredErrorMessage: string;
  if (errorMessage === undefined) {
    const filteredError = error as { data: { detail: string } };
    filteredErrorMessage = filteredError?.data?.detail ?? i18n.t('notifications.error', 'Произошла ошибка');
  } else {
    filteredErrorMessage = i18n.t('notifications.error', 'Произошла ошибка');
  }

  useEffect(() => {
    if (isSuccess) {
      notification.success({
        message: successMessage,
        placement: 'top',
      });
      onSuccess?.();
    }
    if (isError) {
      notification.error({
        message: filteredErrorMessage,
        placement: 'top',
      });
      onError?.();
    }
  }, [isSuccess, isError]);
};
